import { ModalButton, ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType, ModalType } from '@philips-internal/oswald-ui-constants';
import { AbortableCloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import {   } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { SelectedBarcodeExam, submitSelectedExamListFn } from '../../../../interfaces/exam-collect/pending-exam-collection';
import { PendingExamsModalId } from '../../selected-pending-exams/selected-pending-exams-controller';

class PendingExamCollectionModalHandler {
  static beforeModalClose(evt: AbortableCloseEvent): void {
    evt.abort();

    const buttons: ModalButton[] = [];

    buttons.push({
      action: () => { },
      title: 'tws.form.cancel',
      type: ModalButtonType.CANCEL,
    });

    buttons.push({
      action: () => ModalService.close(PendingExamsModalId),
      title: 'tws.wizard.confirm',
      type: ModalButtonType.SUCCESS,
    });

    const dialogModal: ModalProps = {
      closeable: false,
      closeByDocument: false,
      closeByEscape: false,
      dialogDescription: 'tws.selected-pending-exams.close-modal-confirmation',
      dockButtons: buttons,
      focusOnOpen: true,
      onCancel: () => { },
      onSubmit: () => { },
      title: 'text.message-alert-attention',
      type: ModalType.DIALOG,
      uuid: generateUUID(),
    }

    ModalService.openDialog(dialogModal);
  }

  static openPendingExamsModal(beepedBarcodes: SelectedBarcodeExam[], submitSelectedExamList: submitSelectedExamListFn): void {
    const dialogModal: ModalProps = {
      closeByDocument: false,
      closeByEscape: false,
      contextData: {
        selectedBarcodeExams: beepedBarcodes,
        submitSelectedExamList
      },
      focusOnOpen: false,
      fragment: 'selected-pending-exams',
      id: PendingExamsModalId,
      onBeforeClose: PendingExamCollectionModalHandler.beforeModalClose,
      title: 'module.exam-collect',
      type: ModalType.FULLSCREEN,
      uuid: generateUUID(),
    };

    ModalService.openFullscreen(dialogModal);
  }
}

export default PendingExamCollectionModalHandler;